import axios from "axios";

const FETCH_CANDLESTICK_PENDING = "FETCH_CANDLESTICK_PENDING";
const FETCH_CANDLESTICK_SUCCESS = "FETCH_CANDLESTICK_SUCCESS";
const FETCH_CANDLESTICK_ERROR = "FETCH_CANDLESTICK_ERROR";

export const fetchCandlestickPending = () => ({
  type: FETCH_CANDLESTICK_PENDING,
});

export const fetchCandlestickSuccess = (data) => ({
  type: FETCH_CANDLESTICK_SUCCESS,
  payload: data,
});

export const fetchCandlestickError = (error) => ({
  type: FETCH_CANDLESTICK_ERROR,
  payload: error,
});


export const fetchCandlestickData = ({ symbol, candleStickTime, platform, period, setChartLoading, idToken, specificTimes,activeTimeFrame,setRenderInfo}) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  console.log(specificTimes, 'kdjfkdjfkdjf');

  let query = null;
  const { start_date, end_date } = period;
 
  if (candleStickTime) {
    if (specificTimes?.length === 2) {
      const start = new Date(specificTimes[0]);
      const end = new Date(specificTimes[1]);
  
      // Keep start time as-is
      // Adjust end time to one day after
      end.setUTCDate(end.getUTCDate() + 1);    
  
      const startDate = start.toISOString();
      const endDate = end.toISOString();
  
      query = `?start_date=${startDate}&end_date=${endDate}&timeline=${activeTimeFrame}`;
    }
  
    if (specificTimes?.length === 1) {
      const center = new Date(specificTimes[0]);
  
      const start = new Date(center);
      start.setUTCDate(start.getUTCDate() - 1); // 1 day before
  
      const end = new Date(center);
      end.setUTCDate(end.getUTCDate() + 1);     // 1 day after
  
      const startDate = start.toISOString();
      const endDate = end.toISOString();
  
      query = `?start_date=${startDate}&end_date=${endDate}&timeline=${activeTimeFrame}`;
    }
  }
  


  if (!candleStickTime) {
    query = `?start_date=${start_date}&end_date=${end_date}&timeline=${activeTimeFrame}`

  }

  try {
    dispatch(fetchCandlestickPending());
    setChartLoading(true);
    setRenderInfo(false);

    const url = `http://13.41.125.28/api/symbol/${symbol}${query ? query : ""}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...(config?.headers || {}),
      },
    });

    const data = await response.json();

    dispatch(fetchCandlestickSuccess(data));
    setChartLoading(false);
    setRenderInfo(true)
  } catch (error) {
    dispatch(fetchCandlestickError(error?.response?.data || "Fetch failed"));
    setChartLoading(false);
    setRenderInfo(true)
  }
};


const initialState = {
  chartData: [],
  loading: false,
  error: null,
};

const candlestickReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CANDLESTICK_PENDING:
      return {
        chartData: [],
        loading: true,
        error: null,
      };
    case FETCH_CANDLESTICK_SUCCESS:
      return {
        ...state,
        loading: false,
        chartData: action.payload,
      };
    case FETCH_CANDLESTICK_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default candlestickReducer;
